var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectPlugin != null)?_c('iframe',{ref:"iframeExternalPluginProperties",staticStyle:{"width":"100%","height":"93%"},attrs:{"id":"show-plugin","frameBorder":"0"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }